import { Col, Row } from "antd";
import * as React from "react";
import { useBreakpointValue } from "../utils";

type Props = {
  steps: number;
  currentStep: number;
  color?: string;
  progressColor?: string;
};

const StepsIndicator = ({
  steps,
  currentStep,
  color = "#DADEE2",
  progressColor = "#627B66",
}: Props) => {
  const style = useBreakpointValue<React.CSSProperties>({
    base: { height: "4px", width: "132px", borderRadius: "20px" },
    md: { height: "7px", width: "132px", borderRadius: "20px" },
  });
  return (
    <Row style={{ columnGap: "23px" }} wrap={false} justify='center'>
      {Array(steps)
        .fill(0)
        .map((_i, k) => (
          <Col
            key={k}
            style={{ ...style, backgroundColor: currentStep - 1 >= k ? progressColor : color }}
          />
        ))}
    </Row>
  );
};

export default StepsIndicator;
